<template>
    <v-card class="elevation-10 px-5 pt-3 pb-1">
        <!-- form header -->
        <v-card-text>
            <div class="layout column align-center">
                <h2 class="form__recovery-title text-xs-center">
                    Восстановление пароля
                </h2>
                <div class="form__subtitle text-xs-center">
                    данные для входа находятся в приложении к вашему договору
                </div>
            </div>
        </v-card-text>

        <!-- form body -->
        <v-tabs
            active-class="sth"
            color="white"
            slider-color="accent"
            light
            centered
        >
            <!-- SMS -->
            <v-tab class="mr-2">SMS</v-tab>
            <v-tab-item>
                <recoveryFormSms />
            </v-tab-item>

            <!-- Email -->
            <v-tab>e-mail</v-tab>
            <v-tab-item>
                <recoveryFormEmail />
            </v-tab-item>
        </v-tabs>

        <!-- form links block  -->
        <v-card-text>
            <div class="layout column align-center">
                <a
                    class="form__link indigo_5--text text-xs-center"
                    v-on:click="showoLoginForm"
                    >Отменить восстановление пароля</a
                >
            </div>
        </v-card-text>
        <!-- succes message -->
        <div v-if="this.$store.state.showRecoverySuccess">
            <p class="p">
                На вашу почту example@mail.com отправлено письмо с новым
                паролем. Пожалуйста, запишите его в приложение к договору.
            </p>

            <!-- form links block  -->
            <v-card-text>
                <div class="layout column align-center">
                    <a
                        class="form__link indigo_5--text"
                        v-on:click="showoLoginForm"
                        >Вернуться к авторизации</a
                    >
                </div>
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
import recoveryFormSms from '@/components/recoveryFormSms';
import recoveryFormEmail from '@/components/recoveryFormEmail';
export default {
    name: 'recoveryForm',

    components: {
        recoveryFormSms,
        recoveryFormEmail,
    },

    data: () => ({
        recoveryLogin: null,

        rules: {
            required: (value) => !!value || 'Это обязательное поле',
        },
    }),

    methods: {
        showoLoginForm() {
            this.$emit('show', 'recoveryForm');
            this.$store.dispatch('clearServerError');
        },

        validate() {
            if (this.$refs.recoveryForm.validate()) {
                this.$store.dispatch(
                    'recoveryPassword',
                    '7' + this.recoveryLogin
                );
            }
        },

        clearServerError() {
            this.$store.dispatch('clearServerError');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
.form__recovery-title {
    color: #356e8b;
    font-family: 'Fira Sans', sans-serif;
    font-size: 21px;
    font-weight: bold;
}
</style>
